export const buttons = {
    "tips": [
        {"tip": "5%", "value": 0.05},
        {"tip": "10%", "value": 0.10},
        {"tip": "15%", "value": 0.15},
        {"tip": "25%", "value": 0.25},
        {"tip": "50%", "value": 0.50}
    ]
};
